const zh_CN = {
  title: '系统版本',
  frontend: '前端版本',
  backend: '后端版本',
};
export default zh_CN;
